import React from "react";
import styled from "styled-components";
import searchIcon from "assets/images/search_icon.svg";
import Spinner from "components/loader/Spinner";

const Container = styled.label`
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
  align-items: center;
  background-color: #fff;
  cursor: text;
`;

const Icon = styled.div`
  width: 12px;
  height: 12px;
  outline: 0;
  padding: 0;
  border: 0;
  margin-left: 10px;
  background-color: transparent;
  background-image: url("${searchIcon}");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px 12px;
`;

const Input = styled.input`
  flex: 1;
  height: 45px;
  margin: 0;
  padding: 0;
  padding-left: ${props => props.marginLeft || 6}px;
  outline: 0;
  border: 0;
  font-style: inherit;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  background-color: transparent;

  &::placeholder {
    color: ${props => props.theme.searchInputPlaceholderColor};
    font-size: 14px;
  }
`;

const SearchSpinner = styled(Spinner)`
  width: 15px;
  height: 15px;
  margin-right: 10px;
  visibility: ${props => (props.isLoading ? null : "hidden")};
`;

class SearchInput extends React.Component {
  constructor(props) {
    super(props);

    this.inputRef = props.outerRef || React.createRef();
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleContainerMouseDown = this.handleContainerMouseDown.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleInputChange(e) {
    this.handleSearchTermChange(e.target.value);
  }

  handleKeyDown(e) {
    if (this.props.onKeyDown) {
      this.props.onKeyDown(e);
    }

    const inputNode = this.inputRef.current;
    if (this.props.clearOnEscape !== true || e.key !== "Escape" || !inputNode || !inputNode.value) {
      return;
    }

    inputNode.value = "";
    this.handleSearchTermChange("");
    e.stopPropagation();
  }

  handleContainerMouseDown(e) {
    const inputNode = this.inputRef.current;
    if (!inputNode || e.target === inputNode) {
      return;
    }
    e.preventDefault();
    inputNode.focus();
  }

  handleSearchTermChange(value) {
    this.props.onChange(value);
  }

  render() {
    const {
      className,
      type,
      onChange,
      onKeyDown,
      clearOnEscape,
      value,
      isLoading,
      loaderThickness,
      hideSearchIcon,
      rightAccessory,
      ...other
    } = this.props;

    return (
      <Container className={className} onMouseDown={this.handleContainerMouseDown}>
        {!hideSearchIcon === true && <Icon />}
        <Input
          {...other}
          marginLeft={hideSearchIcon === true ? 10 : 6}
          value={value === null ? "" : value}
          ref={this.inputRef}
          type="text"
          onChange={this.handleInputChange}
          onKeyDown={this.handleKeyDown}
          autoComplete="new-password"
          spellCheck="false"
          data-protonpass-ignore
          data-1p-ignore
        />
        <SearchSpinner thickness={loaderThickness} isLoading={!isLoading === false} />
        {rightAccessory}
      </Container>
    );
  }
}

export default SearchInput;
